import React from 'react';
import { devComponentName } from '@morning-dashboard/helpers/isDevEnv';
import { RetryBtn } from '../retry-btn';
import { makeStyles, Text } from '@fluentui/react-components';
import { Box, tokens, useFluentTokens } from '../../../../../theme/fluent';

const useRetryHandlerComponentStyles = makeStyles({
  root: {
    display: 'grid',
    placeItems: 'center',
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
  },
  message: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
  },
});

export type RetryHandlerComponentProps = {
  message?: string;
  onRetry: () => void;
};

const RetryHandlerComponent: React.FC<RetryHandlerComponentProps> = ({ message, onRetry }) => {
  const classes = useRetryHandlerComponentStyles();
  const { modeTokens } = useFluentTokens();
  return (
    <Box {...devComponentName('RetryHandlerComponent')} className={classes.root}>
      <Box className={classes.content}>
        {message && (
          <Text as="span" className={classes.message} style={{ color: modeTokens.colorNeutralForeground1 }}>
            {message}
          </Text>
        )}
        <RetryBtn onRetry={onRetry} />
      </Box>
    </Box>
  );
};

export default RetryHandlerComponent;
